var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"betting-area"},[_c('div',{staticClass:"betting-area-header"},[_vm._v(" "+_vm._s(_vm.$store.getters.translate('general_ticket'))+" ")]),_c('div',{staticClass:"betting-area-content"},[_c('InputsBettingArea'),_c('PreviewBettingArea')],1),(_vm.$store.getters.fullOfferActive)?_c('FullOffer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }